module.exports = __webpack_public_path__ + "static/media/enrandevu-beyaz.1694fc57.png";